import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpurcab() {



const cardData = {
  keyword: " Pune to Nagpur Cab ",

"headingDescription": "Pune to Nagpur Cab service offers a reliable, comfortable, and long-distance travel solution for passengers commuting between Pune and Nagpur. Whether it’s business travel, family trips, or intercity journeys, our professional drivers and well-maintained vehicles ensure a smooth and safe ride. We provide one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Nagpur Cab, enjoy easy online booking, 24/7 customer support, and a hassle-free journey across Maharashtra.",
"topPlaces": [
  {
    "title": "Deekshabhoomi",
    "description": "Deekshabhoomi is a major Buddhist pilgrimage site where Dr. B. R. Ambedkar embraced Buddhism. Travelers booking Pune to Nagpur Cab visit this landmark for its historical and spiritual importance."
  },
  {
    "title": "Sitabuldi Fort",
    "description": "Sitabuldi Fort is a historic fort located in the center of Nagpur. Visitors using Pune to Nagpur Cab explore this site to learn about its role in regional history."
  },
  {
    "title": "Futala Lake",
    "description": "Futala Lake is a popular evening destination known for its lighting and relaxing atmosphere. Travelers using Pune to Nagpur Cab enjoy spending time here with scenic lake views."
  },
  {
    "title": "Ambazari Lake and Garden",
    "description": "Ambazari Lake is one of the largest lakes in Nagpur, surrounded by a beautiful garden. Visitors booking Pune to Nagpur Cab often relax here and enjoy boating and greenery."
  },
  {
    "title": "Raman Science Centre",
    "description": "Raman Science Centre is an educational and interactive museum ideal for families and students. Travelers using Pune to Nagpur Cab explore this place for a fun and learning experience."
  },
  {
    "title": "Dragon Palace Temple",
    "description": "Dragon Palace Temple is a peaceful Buddhist temple known for its serene ambiance. Visitors using Pune to Nagpur Cab visit this temple for meditation and spiritual calm."
  },
  {
    "title": "Maharajbagh Zoo",
    "description": "Maharajbagh Zoo is a small yet popular zoo in Nagpur with various animals and greenery. Travelers booking Pune to Nagpur Cab often visit this place for a family outing."
  },
  {
    "title": "Zero Mile Stone",
    "description": "Zero Mile Stone marks the geographical center of India and is an important landmark in Nagpur. Visitors using Pune to Nagpur Cab often take photos at this historic point."
  },
  {
    "title": "Seminary Hill",
    "description": "Seminary Hill is a green and peaceful area offering panoramic views of the city. Travelers using Pune to Nagpur Cab enjoy this spot for nature and relaxation."
  },
  {
    "title": "Gorewada Lake",
    "description": "Gorewada Lake is a scenic destination known for its calm surroundings and wildlife area. Visitors booking Pune to Nagpur Cab enjoy nature and outdoor activities here."
  }
],



services: [
{
name: "Pune to Nagpur Cab Service",
description: "Pune to Nagpur cab service offers reliable long-distance travel across Maharashtra. Customers can book cabs for business and personal trips. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance long travel experience. Flexible booking options are available. Travel easily from Pune to Nagpur with cab services."
},
{
name: "Pune to Nagpur Taxi Booking",
description: "Pune to Nagpur taxi booking provides quick and easy reservation options. Customers can book taxis online or via mobile apps. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Nagpur taxi easily."
},
{
name: "Pune to Nagpur Car Rental",
description: "Pune to Nagpur car rental offers flexible vehicle options for long-distance travel. Customers can choose from sedan, SUV, and premium cars. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars from Pune to Nagpur for convenient travel."
},
{
name: "Pune to Nagpur One-Way Taxi",
description: "Pune to Nagpur one-way taxi offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Transparent pricing ensures affordability. Choose one-way taxi services for Pune to Nagpur travel."
},
{
name: "Pune to Nagpur Round Trip Cabs",
description: "Pune to Nagpur round trip cabs provide convenient two-way travel options. Customers can plan return journeys with flexible schedules. Comfortable vehicles ensure smooth highway travel. Professional drivers ensure safe journeys. Transparent pricing ensures value for money. Book round trip cabs for Pune to Nagpur trips."
},
{
name: "Pune to Nagpur Luxury Taxi",
description: "Pune to Nagpur luxury taxi offers premium travel experience with high-end vehicles. Customers can enjoy extra comfort for long journeys. Professional chauffeurs ensure safe travel. Ideal for corporate and VIP travel needs. Flexible booking options are available. Experience luxury travel from Pune to Nagpur."
},
{
name: "Pune to Nagpur Cabs",
description: "Pune to Nagpur cabs provide reliable transportation for intercity travel. Customers can choose from multiple vehicle options. Professional drivers ensure safe journeys. One-way and round trip options are available. Transparent pricing ensures affordability. Travel comfortably from Pune to Nagpur with cab services."
},
{
name: "Cab Pune to Nagpur",
description: "Cab Pune to Nagpur offers convenient travel solutions for long-distance trips. Customers can book cabs for flexible schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cab services from Pune to Nagpur."
},
{
name: "Pune to Nagpur Cab Booking",
description: "Pune to Nagpur cab booking provides easy and fast reservation options. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Nagpur cab easily."
},
{
name: "Pune to Nagpur Cab Charges",
description: "Pune to Nagpur cab charges provide clear pricing details for travelers. Customers can check charges before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Nagpur Taxi",
description: "Pune to Nagpur taxi service offers convenient transportation for long-distance travel. Customers can book taxis for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pune to Nagpur."
},
{
name: "Pune to Nagpur Taxi Fare",
description: "Pune to Nagpur taxi fare provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent fare."
},
{
name: "Pune to Amravati Cab Booking",
description: "Pune to Amravati cab booking offers convenient travel for long-distance trips. Customers can book cabs online easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Amravati."
},
{
name: "Pune to Amravati Taxi",
description: "Pune to Amravati taxi provides reliable transportation for intercity travel. Customers can book taxis for business or family trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel smoothly from Pune to Amravati."
},
{
name: "Amravati to Pune Cab Service",
description: "Amravati to Pune cab service offers convenient return travel options. Customers can book cabs for long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Amravati to Pune."
},
{
name: "Pune to Akola Cab",
description: "Pune to Akola cab provides comfortable travel for intercity journeys. Customers can book cabs for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Pune to Akola."
},
{
name: "Pune to Akola Cab Service",
description: "Pune to Akola cab service offers reliable transportation for long-distance trips. Customers can book cabs for business and leisure travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel smoothly with cab services."
},
{
name: "Pune to Bhandara Cab",
description: "Pune to Bhandara cab offers convenient travel for intercity trips. Customers can book cabs for long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Pune to Bhandara."
},
{
name: "Pune to Buldhana Cab",
description: "Pune to Buldhana cab service provides reliable transportation for long-distance travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Pune to Buldhana."
},
{
name: "Pune to Buldhana Cab Service",
description: "Pune to Buldhana cab service offers dependable travel options for passengers. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Buldhana Cab Fare",
description: "Pune to Buldhana cab fare provides clear pricing details for travelers. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent fare."
},
{
name: "Pune to Chandrapur Taxi Service",
description: "Pune to Chandrapur taxi service offers reliable long-distance transportation. Customers can book taxis for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Chandrapur."
},
{
name: "Pune to Chandrapur Car Rental",
description: "Pune to Chandrapur car rental provides flexible vehicle options for long-distance travel. Customers can choose from multiple car types. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars for Pune to Chandrapur travel."
},
{
name: "Pune to Gadchiroli Cab Service",
description: "Pune to Gadchiroli cab service offers reliable transportation for remote destinations. Customers can book cabs for long-distance travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Gadchiroli."
},
{
name: "Pune to Gadchiroli Cab Taxi Fare",
description: "Pune to Gadchiroli cab taxi fare provides pricing details for travel planning. Customers can check fare estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services."
},
{
name: "Pune to Nagpur One Way Cab",
description: "Pune to Nagpur one way cab offers economical travel without return charges. Customers can book direct one-way rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Nagpur."
},
{
name: "Pune to Nagpur One Way Taxi",
description: "Pune to Nagpur one way taxi provides convenient travel options for passengers. Customers can book taxis for direct journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way taxi services."
}
],

tableData: [
["Pune to Nagpur Cab Service","Pune to Nagpur Taxi Booking"],
["Pune to Nagpur Car Rental","Pune to Nagpur One-Way Taxi"],
["Pune to Nagpur Round Trip Cabs","Pune to Nagpur Luxury Taxi"],
["Pune to Nagpur Cabs","Cab Pune to Nagpur"],
["Pune to Nagpur Cab Booking","Pune to Nagpur Cab Charges"],
["Pune to Nagpur Taxi","Pune to Nagpur Taxi Fare"],
["Pune to Amravati Cab Booking","Pune to Amravati Taxi"],
["Amravati to Pune Cab Service","Pune to Akola Cab"],
["Pune to Akola Cab Service","Pune to Bhandara Cab"],
["Pune to Buldhana Cab","Pune to Buldhana Cab Service"],
["Pune to Buldhana Cab Fare","Pune to Chandrapur Taxi Service"],
["Pune to Chandrapur Car Rental","Pune to Gadchiroli Cab Service"],
["Pune to Gadchiroli Cab Taxi Fare","Pune to Nagpur One Way Cab"],
["Pune to Nagpur One Way Taxi","Pune to Nagpur Cab Service"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Nagpur routes, ensuring safe highway driving, proper rest planning, and smooth long-distance travel."
  },
  {
    WhyChooseheading: "Affordable Pune to Nagpur Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Nagpur cab services with transparent pricing. Customers receive full fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Nagpur cab bookings, making it convenient for business travel, family trips, and urgent long-distance journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes well-maintained, air-conditioned vehicles designed for long-distance comfort, ensuring a relaxed journey from Pune to Nagpur."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel plans for Pune to Nagpur journeys based on customer requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individual, family, and corporate travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Nagpur cab bookings due to punctual service, professional drivers, and reliable vehicles for long-distance travel."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Nagpur cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Nagpur for long-distance travel." },
  { question: "How far is Nagpur from Pune?", answer: "The distance between Pune and Nagpur is approximately 700 km and the journey takes around 12 to 14 hours depending on route and traffic." },
  { question: "Is Pune to Nagpur cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Nagpur travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Nagpur?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide multi-day travel options?", answer: "Yes, we offer customized multi-day travel plans for Pune to Nagpur journeys." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Nagpur cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pravin Deshmukh",
    feedback:
      "Booked SRS Cab Service for Pune to Nagpur trip. Long journey was very smooth and driver was professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Kulkarni",
    feedback:
      "Excellent Pune to Nagpur cab service. Comfortable ride and perfect for long-distance family travel.",
    rating: 5
  }
];

































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nagpur Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Nagpur cab services including one-way and round trips, luxury cabs, taxi bookings, and car rentals. Book online for safe, comfortable, and punctual rides from Pune to Nagpur with affordable fares and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Pune to Nagpur Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Nagpur cabs with SRS Cab. One-way, round trips, luxury cabs, taxi bookings, and car rentals. Safe, comfortable, and punctual rides from Pune to Nagpur with 24x7 online booking and affordable fares." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>





 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonagpurcab;